import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-nao-encontrado',
  templateUrl: './nao-encontrado.component.html',
  standalone: true,
  styleUrls: ['./nao-encontrado.component.scss']
})
export class naoEncontradoComponent {
  @Input() texto: any;
}
